<div layout-horizontal layout-justify-flex-end layout-align-items-center>
  <rt-group margin-lr margin-tb-medium layout-justify-flex-end>
    <rt-button (click)="close.emit()" variant="plain">
      {{ 'app.interview.cancel' | translate }}
    </rt-button>
    <rt-button [disabled]="!isFormValid()" (click)="submit.emit()" variant="primary">
      {{ primaryActionLabelKey() | translate }}
    </rt-button>
  </rt-group>
</div>
